<template>
  <div class="btmBanner" id="bannerBtm">
    <img src="../common/images/banner/btmBanner.png" class="btmBanner_img"/>
    <div class="btm_content">
      版权所有：山东点服环境科技有限公司 鲁ICP备11009125号-9<br />服务热线：0531-62323890
    </div>
  </div>
</template>

<script>
  export default{
    name:'btmBanner',
  }
</script>

<style>
  .btmBanner{
    width: 1920px;
    height:249px;
    position: relative;
  }
  .btmBanner_img{
    width: 1920px;
    height:249px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .btm_content{
    width: 1520px;
    height: 104px;
    line-height: 52px;
    padding: 72px 200px;
    color: #fff;
    font-size: 24px;
    z-index: 9;
    position: absolute;
    left: 0;
    top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/btmBanner.vue